import { useState, useMemo } from 'react';
import { Form, OverlayTrigger, Tooltip, Modal } from 'react-bootstrap';
import { withStore } from 'store';
import { MinimalistCard } from 'components/Cards';
import { CustomIcon } from 'components';
import { getGiftTableLink } from 'services/commons';
import linkIcon from 'assets/img/link_icon.svg';
import { VARIANTS } from './config';
import styles from './styles.module.scss';

const LABEL = 'Copia y comparte el enlace';

function ShareLink({
  url: externalUrl = '',
  variant = VARIANTS.DEFAULT,
  giftTable,
  loading,
}) {
  const isMinimalist = variant === VARIANTS.MINIMALIST;
  const [tooltipp, setTooltip] = useState('Copiar');
  const [showModal, setShowModal] = useState(false);

  const handleClick = () => {
    if (!loading && url) {
      navigator.clipboard.writeText(url);
      setTooltip('Copiado');
      setShowModal(true);
      setTimeout(() => {
        setShowModal(false);
      }, 2000);
    }
  };

  const url = useMemo(
    () => (loading ? 'Cargando...' : getGiftTableLink(giftTable)),
    [giftTable, externalUrl, loading]
  );

  const renderInput = (
    <div
      className={
        isMinimalist
          ? `${styles.shareLinkInputContainer} align-items-center`
          : 'position-relative'
      }
    >
      {/*isMinimalist ? (
        <h6 className="text-primary m-0 text-overflow-ellipsis">{url}</h6>
      ) : (
        <Form.Control
          className={styles.shareLinkInput}
          name="url"
          type="text"
          readOnly
          value={url}
          alt="Url de la mesa de regalos"
        />
      )*/}
        <button
          type="button"
          onClick={handleClick}
          className={
            isMinimalist
              ? styles.copyLinkButtonMinimalist
              : styles.copyLinkButton
          }
        >
          <img src={linkIcon} alt="Copiar link" />
        </button>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Body>Copiado</Modal.Body>
      </Modal>
    </div>
  );

  const defaultRender = (
    <div className={styles.shareLink}>
      {/*<label htmlFor="url">{LABEL}</label>*/}
      {renderInput}
    </div>
  );

  const minimalistRender = (
    <MinimalistCard
      className={`${styles.shareLinkMinimalist} align-items-start justify-content-center`}
    >
      {/*<h6 className="m-0">{LABEL}</h6>*/}
      {renderInput}
    </MinimalistCard>
  );

  const extraSmallRender = (
    <CustomIcon onClick={handleClick} variant="square" icon={linkIcon} />
  );

  const RENDERS_BY_VARIANT = {
    [VARIANTS.DEFAULT]: defaultRender,
    [VARIANTS.MINIMALIST]: minimalistRender,
    [VARIANTS.EXTRA_SMALL]: extraSmallRender,
  };

  return RENDERS_BY_VARIANT[variant];
}

export default withStore({
  mapStateToProps: (state) => ({
    giftTable: state.giftTable.giftTable,
    loading: state.giftTable.giftTableInfo.loading,
  }),
})(ShareLink);
